import React from 'react'
import { Platform, View } from 'react-native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text, Button, Icon } from '@components/base'
import { FadeFromBottomModal } from '@components'
import { useGoBack } from '@src/utils/navigation'
import { requestInAppReview } from '@utils/appReview'
import { Analytics, CustomEventTypes } from '@config'
import { userSelector } from '@selectors/app.ts'

export const PositiveRatingModal = () => {
  const styles = useStyleSheet(themedStyles)
  const user = useSelector(userSelector)

  const goBack = useGoBack()

  const onRateButtonPress = () => {
    requestInAppReview()
    Analytics.track(CustomEventTypes.AppRatingOpened, {
      userId: user?.id,
    })
    goBack()
  }

  const onDismiss = () => {
    Analytics.track(CustomEventTypes.AppRatingSkipped, {
      userId: user?.id,
    })
    goBack()
  }

  return (
    <FadeFromBottomModal closeModal={onDismiss} contentStyles={styles.content}>
      <View style={styles.container}>
        <Icon name="heart" style={styles.heartIcon} />
        <Text type="title-2" style={styles.title}>
          Thank you for your feedback!
        </Text>
        <Text type="regular" style={styles.subtitle}>
          We’re so glad you’re enjoying Nutrisense. Please take a few seconds to rate us in the{' '}
          {Platform.OS === 'android' ? 'Play' : 'App'}
          Store - it would mean a lot!
        </Text>
        <Button
          type="primary"
          size="block"
          style={styles.confirmButton}
          onPress={onRateButtonPress}
          accessibilityLabel="rateButton"
        >
          Rate
        </Button>
        <Button
          type="transparent"
          size="block"
          accessibilityLabel="Dismiss Button"
          onPress={onDismiss}
        >
          Dismiss
        </Button>
      </View>
    </FadeFromBottomModal>
  )
}

const themedStyles = StyleService.create({
  content: {
    backgroundColor: 'theme.background',
  },
  container: {
    marginTop: 8,
  },
  title: {
    textAlign: 'center',
    marginBottom: 24,
    marginHorizontal: 32,
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: 24,
    marginHorizontal: 24,
    color: 'theme.text.secondary',
  },
  confirmButton: {
    marginBottom: 8,
  },
  heartIcon: {
    margin: 'auto',
    width: 48,
    marginBottom: 24,
  },
})
